import { render } from "./SpaceFormPageFour.vue?vue&type=template&id=4d484eb4"
import script from "./SpaceFormPageFour.vue?vue&type=script&lang=js"
export * from "./SpaceFormPageFour.vue?vue&type=script&lang=js"
script.render = render

export default script